module.exports = __webpack_public_path__ + "static/media/serverError.79bf5005.svg";